<template>

    <div
        class="c-loader"
        :class="getClasses">
        <div class="c-loader__spinner"></div>
    </div>

</template>


<script>

export default {

    name: 'VLoader',

    props: {
        loading: Boolean,
        fullScreen: Boolean
    },

    computed: {
        getClasses() {
            return {
                'c-loader--fixed': this.fullScreen,
                'c-loader--active': this.loading
            }
        }
    },

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-loader {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9;
    width: 100%;
    height: 100%;
    visibility: hidden;
    pointer-events: none;
    opacity: 0;
    transition: opacity .1s ease-in-out, visibility 0s .1s linear;
    background-color: $c-white;

    &--active {
        transition-delay: 0s;
        opacity: 1;
        visibility: visible;
    }
    &--fixed {
        z-index: 99;
        position: fixed;
    }
    &__spinner {
        width: 50px;
        height: 50px;
        margin: 100px auto;
        background-color: $c-primary;
        border-radius: 100%;
        animation: loader-scaleout 1.0s infinite ease-in-out;
    }
}
@keyframes loader-scaleout {
    0% {
        transform: scale(0);
    }
    100% {
        transform: scale(1.0);
        opacity: 0;
    }
};

</style>
